import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getGiftOrders } from "../api";
import { giftOrdersKeys } from "./keys";
import type { GiftOrdersListResponse, QueryParams } from "../../types";

export const useGiftOrdersQuery = (params: QueryParams | null) => {
  return useQuery<GiftOrdersListResponse>({
    queryKey: giftOrdersKeys.list(params as QueryParams),
    queryFn: async () => {
      const { data } = await getGiftOrders(
        params?.page || 1,
        params?.perSize || 10,
        params?.search || ({} as QueryParams["search"]),
      );
      return {
        data: data?.data || [],
        totalItems: data?.totalItems || 0,
      };
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
};
